<template>
  <div>
    <!-- 顶部菜单 -->
    <div class="nav">
      <div class="navContent">
        <img class="logo" src="../assets/images/home/logo.png" alt />
        <div class="navlist">
          <ul>
            <li
              v-for="(item, i) in navData"
              :class="{ active : active === i }"
              :key="i"
              @click="$router.push({ path: item.path }), navMenu(i), saveNavState(i), clickH5Menu(item.name)"
            >{{item.name}}</li>
          </ul>
          <i class="selectLine"></i>
        </div>
        <div class="navmenu">
          <span class="menuActive" @click="setH5Menu()">{{activeName}}</span>
          <img src="../assets/images/home/arrow.png" alt />
          <ul :class="h5Menu ? '':'dp-n'">
            <li
              v-for="(item, i) in navData"
              :class="{ active : active === i }"
              :key="i"
              @click="$router.push({ path: item.path }), navMenu(i),saveNavState(i), clickH5Menu(item.name)"
            >{{item.name}}</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 路由占位符 -->
    <div style="height:70px"></div>
    <router-view @active="getActive" :inputValue='inputValue'></router-view>
    <!-- 底部信息 -->
    <div class="buttom">
      <!-- 橙色块 -->
      <div class="bottomNavigation">
        <div class="bottomNavigationContent">
          <!-- 组织架构 -->
          <div>
            <div class="title">组织架构</div>
            <ul>
              <li @click="saveNavState(5), navMenu(5), $router.push({ path:'/about'})">
                部门划分
              </li>
            </ul>
          </div>
          <!-- 业务服务范围 -->
          <div>
            <div class="title">业务服务范围</div>
            <ul>
              <li @click="saveNavState(2), navMenu(2), $router.push({ path:'/work'})">
                线上营销策划与执行
              </li>
              <li @click="saveNavState(2), navMenu(2), $router.push({ path:'/work'})">
                线下营销策划与执行
              </li>
              <li @click="saveNavState(2), navMenu(2), $router.push({ path:'/work'})">
                营销策划与明细
              </li>
            </ul>
          </div>
          <!-- 近期动态 -->
          <div>
            <div class="title">近期动态</div>
            <ul>
              <li @click="saveNavState(3), navMenu(3),saveNavState(3), $router.push({ path:'/online'})">
                线上活动
              </li>
              <li @click="saveNavState(4), navMenu(4), $router.push({ path:'/underline'})">
                线下活动
              </li>
            </ul>
          </div>
          <!-- 加入我们 -->
          <div>
            <div class="title">加入我们</div>
            <ul>
              <li @click="saveNavState(6), navMenu(6), setInputValue(0), $router.push({ path:'/join/Recruits'})">
                在招岗位
              </li>
              <li @click="saveNavState(6), navMenu(6), setInputValue(1), $router.push({ path:'/join/Welfare'})">
                公司福利
              </li>
            </ul>
          </div>
          <!-- 联系我们 -->
          <div>
            <div class="title">联系我们</div>
            <ul>
              <li>成都（总部）</li>
              <li>成都市领事馆路7号保利中心南塔2405号</li>
              <li>联系电话：028-8670 3442</li>
            </ul>
          </div>
        </div>
        <div class="qrcode">
          <div>
            <img src="../assets/images/home/microOfficialWebsite.png" alt />
            <div>易互动微官网</div>
          </div>
          <div>
            <img src="../assets/images/home/officialAccount.png" alt />
            <div>易互动公众号</div>
          </div>
        </div>
      </div>
      <!-- 灰色块 -->
      <div class="copyright">
        <div class="copyrightContent">
          © 2018 EIM 四川易互动营销策划有限公司
          <a
            target="_blank"
            href="https://beian.miit.gov.cn/"
          >蜀ICP备14029536号</a>
          公司版权所有
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
export default {
  data() {
    return {
      active: 0,
      activeName: '首页',
      navData: [
        { name: '首页', path: '/welcome' },
        { name: '公司介绍', path: '/company' },
        { name: '业务范围', path: '/work' },
        { name: '线上案例', path: '/online' },
        { name: '线下案例', path: '/underline' },
        { name: '关于我们', path: '/about' },
        { name: '加入我们', path: '/join' }
      ],
      h5Menu: false,
      inputValue: 0
    }
  },
  mounted() {
    if (window.sessionStorage.getItem('caseid') !== null) {
      this.caseid = parseInt(window.sessionStorage.getItem('caseid'))
      console.log(this.caseid)
    }
    this.active = parseInt(window.sessionStorage.getItem('navActive'))
    this.navMenu(this.active)
  },
  methods: {
    // 选中线移动函数
    menuSelection(right) {
      anime({
        targets: '.navlist .selectLine',
        right: right
      })
    },
    // 判断选中线移动到指定位置
    navMenu(index) {
      if (index === 0) {
        this.menuSelection('600px')
      } else if (index === 1) {
        console.log(index)
        this.menuSelection('500px')
      } else if (index === 2) {
        this.menuSelection('400px')
      } else if (index === 3) {
        this.menuSelection('300px')
      } else if (index === 4) {
        this.menuSelection('200px')
      } else if (index === 5) {
        this.menuSelection('100px')
      } else if (index === 6) {
        this.menuSelection('0px')
      }
    },
    // 保存链接的激活状态
    saveNavState(active) {
      window.sessionStorage.setItem('navActive', active)
      this.active = active
      if (active === 3) {
        window.sessionStorage.setItem('onlineActive', 0)
      }
      if (active === 6) {
        window.sessionStorage.setItem('joinActive', 0)
      }
    },
    setInputValue(val) {
      this.inputValue = val
    },
    // 展开h5菜单
    setH5Menu() {
      this.h5Menu = !this.h5Menu
    },
    // 点击h5菜单操作
    clickH5Menu(name) {
      this.activeName = name
      this.h5Menu = false
    },
    getActive(active) {
      this.active = active
    }
  }
}
</script>

<style scoped>
.nav {
  width: 100%;
  height: 70px;
  background-color: #fff;
  box-shadow: 0px 3px 18px #e5e6ea;
  position: fixed;
  top: 0;
  z-index: 999;
}
.nav .navContent {
  width: 100%;
  height: 100%;
  max-width: 1100px;
  min-width: 320px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav .navContent .logo {
  padding-left: 20px;
}

@media screen and (min-width: 850px) {
  /* pc菜单 */
  .nav .navContent .navlist {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }
  .nav .navContent .navlist ul {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .navlist ul li {
    width: 100px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
  }
  .navlist .selectLine {
    width: 100px;
    height: 2px;
    position: absolute;
    right: 600px;
    bottom: 0;
    background-color: #ea5804;
  }
  .navlist ul li.active {
    color: #e94615;
  }
  .navlist ul li:hover {
    color: #e94615;
  }
  /* 手机端菜单 */
  .nav .navContent .navmenu {
    display: none;
  }
  /* 底部样式 */
  .buttom {
    width: 100%;
    background-color: #ea5804;
  }
  .buttom .bottomNavigation {
    width: 100%;
    max-width: 1100px;
    min-width: 320px;
    margin: 0 auto;
    color: #fff;
    padding-top: 30px;
  }
  .buttom .bottomNavigation .bottomNavigationContent {
    display: flex;
    justify-content: space-between;
  }
  .bottomNavigationContent .title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  .bottomNavigationContent ul li {
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .bottomNavigationContent ul li a {
    color: #fff;
  }
  .buttom .copyright {
    height: 40px;
    background-color: #f4f4f4;
    color: #666666;
    font-size: 12px;
    line-height: 40px;
    text-align: center;
  }
}
@media screen and (max-width: 849px) {
  /* pc菜单 */
  .nav .navContent .navlist {
    display: none;
  }
  /* 手机端菜单 */
  .nav .navContent .navmenu {
    position: relative;
    padding-right: 20px;
    width: 100px;
  }
  .nav .navContent .navmenu .menuActive {
    color: #e94615;
  }
  .nav .navContent .navmenu .menuActive p {
    width: 40px;
  }
  .nav .navContent .navmenu img {
    height: 30px;
    vertical-align: middle;
  }
  .nav .navContent .navmenu ul {
    position: absolute;
    top: 70px;
    right: 0px;
    width: 100px;
    text-align: center;
    background-color: #fff;
    padding: 4px;
    border-radius: 4px;
    box-shadow: 0px 3px 18px #e5e6ea;
  }
  .nav .navContent .navmenu ul li {
    height: 32px;
    line-height: 32px;
  }
  .nav .navContent .navmenu ul li.active {
    color: #e94615;
  }
  /* 底部菜单 */
  .buttom .bottomNavigation .bottomNavigationContent {
    display: none;
  }
  .buttom .copyright {
    padding: 0px 20px;
    height: 40px;
    background-color: #f4f4f4;
    color: #666666;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
  }
}

.bottomNavigation .qrcode {
  padding: 30px 0;
  min-width: 320px;
  display: flex;
  justify-content: center;
  background-color: #ea5804;
  color: #fff;
}
.bottomNavigation .qrcode div {
  width: 160px;
  text-align: center;
}
</style>
